module.exports = __webpack_public_path__ + "static/media/TitleExtensionExample@2x.c335239eb86e54a675f534917aa43a32.jpg";